import ReactEDSWrapper from '../../utils/react-eds-wrapper';
import { Button, Card, Tag } from '@dsi/react-eds';
import { NiiRunStatus } from './types/nii.types';
import styles from './NiiLandingPage.module.css';

interface ReportCardProps {
  title: string;
  status: NiiRunStatus;
  onView: () => void;
  onRegenerate?: () => void;
  createdAt?: string;
  createdBy?: string | null;
  dataSourceKind?: 'enm_live' | 'upload' | null;
  enmEndpointName?: string | null;
  uploadFilename?: string | null;
}

const STATUS_TAG: Record<string, { label: string; color: string }> = {
  [NiiRunStatus.COMPLETE]: { label: 'Available', color: 'green' },
  [NiiRunStatus.QUEUED]: { label: 'Queued', color: 'grey' },
  [NiiRunStatus.RUNNING]: { label: 'Running', color: 'blue' },
  [NiiRunStatus.ERROR]: { label: 'Error', color: 'red' },
  [NiiRunStatus.CANCELLED]: { label: 'Cancelled', color: 'grey' }
};

function formatTimestamp(iso: string): string {
  try {
    return new Date(iso).toLocaleString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch {
    return iso;
  }
}

const ReportCard: React.FC<ReportCardProps> = ({
  title,
  status,
  onView,
  onRegenerate,
  createdAt,
  createdBy,
  dataSourceKind,
  enmEndpointName,
  uploadFilename
}) => {
  const tag = STATUS_TAG[status] || STATUS_TAG[NiiRunStatus.COMPLETE];

  return (
    <div className={styles.cardWrapper}>
      <ReactEDSWrapper component={Card} title={title}>
        <div className={styles.card}>
          <div className={styles.tagWrapper}>
            <ReactEDSWrapper component={Tag} color={tag.color} big>
              {tag.label}
            </ReactEDSWrapper>
          </div>

          {createdAt && (
            <div className={styles.reportCardMeta}>
              <span>Created: {formatTimestamp(createdAt)}</span>
            </div>
          )}

          {createdBy && (
            <div className={styles.reportCardMeta}>
              <span>Created by: {createdBy}</span>
            </div>
          )}

          {dataSourceKind === 'enm_live' && enmEndpointName && (
            <div className={styles.reportCardMeta}>
              <span>ENM: {enmEndpointName}</span>
            </div>
          )}

          {dataSourceKind === 'upload' && (
            <div className={styles.reportCardMeta}>
              <span>Source: {uploadFilename || 'Uploaded data'}</span>
            </div>
          )}

          <div className={styles.cardActions}>
            <ReactEDSWrapper component={Button} primary onClick={onView}>
              View
            </ReactEDSWrapper>
            {onRegenerate && (
              <ReactEDSWrapper component={Button} onClick={onRegenerate}>
                <i className="icon icon-reload" style={{ marginRight: '4px' }} />
                Regenerate
              </ReactEDSWrapper>
            )}
          </div>
        </div>
      </ReactEDSWrapper>
    </div>
  );
};

export default ReportCard;
